export const STATECRAFT_LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_kpsc-mcq-prep/artifacts/y6sh3189_logo%28800%20by%20500%20px%29%20%28002%29%20updated.jpg";
